<template lang="html">
  <i-btn
    color="warning"
    icon="mdi-delete"
    @click="$emit('click', $event)"/>
</template>

<script>
import IconButton from './IconButton'

export default {
  components: {
    'i-btn': IconButton
  }
}
</script>

<style lang="css" scoped>
</style>
